export enum GradesMutations {
  RESET = "RESET",
}
